import { render, staticRenderFns } from "./langSwitcher.vue?vue&type=template&id=4683d9ad&scoped=true&"
import script from "./langSwitcher.vue?vue&type=script&lang=js&"
export * from "./langSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4683d9ad",
  null
  
)

export default component.exports